import * as React from 'react'
import { SVGProps } from 'react'
const SvgBraintreeCard = (props: SVGProps<SVGSVGElement>) => (
  <svg
    className="-s-braintree-cvv"
    width={27}
    height={18}
    viewBox="0 0 27 18"
    fill="none"
    {...props}
  >
    <path
      d="M0 3a3 3 0 0 1 3-3h21a3 3 0 0 1 3 3v12a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3Z"
      fill="#E6E9EB"
    />
    <path fill="#B9C4C9" d="M4 12h19v2H4z" />
    <rect x={4} y={4} width={4} height={4} rx={1} fill="#fff" />
  </svg>
)
export default SvgBraintreeCard
